// import { useEditor, EditorContent } from '@tiptap/react';
import * as tiptap from '@tiptap/react';

import StarterKit from '@tiptap/starter-kit';
import { useEffect } from 'react';
import c from './rich-text-editor.module.scss';

const MenuBar = ({ editor }) => {
  return (
    <div className={c.controlContainer}>
      <div className={c.buttons}>
        <button
          type="button"
          onClick={() => editor.chain().focus().toggleBold().run()}
          disabled={!editor.can().chain().focus().toggleBold().run()}
          className={editor.isActive('bold') ? c.active : ''}
        >
          Bold
        </button>

        <button
          type="button"
          onClick={() => editor.chain().focus().setParagraph().run()}
          className={editor.isActive('paragraph') ? c.active : ''}
        >
          Paragraph
        </button>
        <button
          type="button"
          onClick={() =>
            editor.chain().focus().toggleHeading({ level: 1 }).run()
          }
          className={editor.isActive('heading', { level: 1 }) ? c.active : ''}
        >
          H1
        </button>
        <button
          type="button"
          onClick={() =>
            editor.chain().focus().toggleHeading({ level: 2 }).run()
          }
          className={editor.isActive('heading', { level: 2 }) ? c.active : ''}
        >
          H2
        </button>
        <button
          type="button"
          onClick={() =>
            editor.chain().focus().toggleHeading({ level: 3 }).run()
          }
          className={editor.isActive('heading', { level: 3 }) ? c.active : ''}
        >
          H3
        </button>
        <button
          type="button"
          onClick={() => editor.chain().focus().toggleBulletList().run()}
          className={editor.isActive('bulletList') ? c.active : ''}
        >
          Bullet list
        </button>
        <button
          type="button"
          onClick={() => editor.chain().focus().toggleOrderedList().run()}
          className={editor.isActive('orderedList') ? c.active : ''}
        >
          Ordered list
        </button>
      </div>
    </div>
  );
};
const RichTextEditor = ({ value, onBlur, onChange, disabled, display }) => {
  const extensions = [
    StarterKit.configure({
      bulletList: {
        keepMarks: true,
        keepAttributes: false,
      },
      orderedList: {
        keepMarks: true,
        keepAttributes: false,
      },
    }),
  ];
  const editor = tiptap.useEditor({
    editable: !disabled,
    extensions,
    content: value || { type: 'doc', content: [{ type: 'paragraph' }] },
    onUpdate({ editor }) {
      const json = editor.getJSON();
      onChange && onChange(json);
      onBlur && onBlur(json);
    },
  });

  useEffect(() => {
    if (editor) {
      editor.setEditable(!disabled);
    }
  }, [disabled, editor]);

  useEffect(() => {
    if (editor && value) {
      const current = editor.getJSON();
      if (JSON.stringify(current) !== JSON.stringify(value)) {
        editor.commands.setContent(value);
      }
    }
  }, [value, editor]);

  if (!editor) return null;

  return (
    <div className={`${c.editorContainer} ${display && c.display}`}>
      {editor && !disabled && !display && <MenuBar editor={editor} />}
      <div className={c.editor}>
        {editor && <tiptap.EditorContent editor={editor} />}
      </div>
    </div>
  );
};

export default RichTextEditor;
